import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  successHistory: [],
  failedHistory: [],
  users: new Map(),
  usersInit: false,
};

const reducers = {
  getSuccessHistory(state, action) {
    state.successHistory = action.payload;
  },
  getFailedHistory(state, action) {
    state.failedHistory = action.payload;
  },
  getUsers(state, action) {
    const map = new Map();
    const users = action.payload;
    for (var user of users) {
      map.set(user.userId, user);
    }
    state.users = map;
    state.usersInit = true;
  },
};

export const slice = createSlice({
  name: "admin",
  initialState,
  reducers,
});

export const { reducer } = slice;
